import { useNavigate } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import CourseFAQ from "../inscricao/components/CourseFAQ";

const products = [
  {
    slug: "/inscricao",
    tag: "Para Vendedoras",
    title: "Método C.A.T",
    role: "Vendedora",
    description:
      "Ideal para vendedoras que querem dominar técnicas de atendimento, aumentar comissões e se destacar no varejo.",
    highlights: ["Técnicas de vendas e neuro vendas", "WhatsApp Business & CRM", "TikTok Shop e IA", "Dress code e apresentação pessoal"],
    price: "R$ 498,50",
    kiwifyUrl: "https://pay.kiwify.com.br/MThLhMv",
    image: "https://readdy.ai/api/search-image?query=confident%20elegant%20saleswoman%20in%20a%20modern%20retail%20boutique%20with%20golden%20warm%20lighting%2C%20premium%20fashion%20store%20interior%2C%20stylish%20professional%20woman%20smiling%2C%20minimalist%20aesthetic%20with%20marble%20floors%20and%20white%20walls%2C%20sophisticated%20and%20aspirational%20atmosphere%2C%20high-end%20retail%20environment&width=600&height=700&seq=prod-vendedora1&orientation=portrait",
  },
  {
    slug: "/gerente",
    tag: "Para Gerentes",
    title: "Método C.A.T",
    role: "Gerente",
    description:
      "Para gerentes e líderes que precisam engajar equipes, bater metas e criar uma cultura de alta performance.",
    highlights: ["Liderança e gestão de equipes", "KPIs e indicadores de performance", "Recrutamento e treinamento", "Gestão de conflitos e clima"],
    price: "R$ 984,50",
    kiwifyUrl: "https://pay.kiwify.com.br/tJPadIg",
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20elegant%20Black%20woman%20store%20manager%20with%20a%20high-class%20sophisticated%20expression%2C%20wearing%20a%20refined%20tailored%20cream%20blazer%2C%20standing%20in%20a%20luxury%20boutique%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20marble%20floors%2C%20polished%20professional%20look%2C%20flawless%20natural%20makeup%2C%20aspirational%20powerful%20presence%2C%20editorial%20fashion%20photography%20style%2C%20clean%20modern%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20dark%20skin%20glowing%20with%20soft%20studio%20light%2C%20luxury%20retail%20atmosphere%2C%20strong%20yet%20warm%20leadership%20aura&width=600&height=700&seq=prod-gerente2&orientation=portrait",
  },
  {
    slug: "/lojista",
    tag: "Para Lojistas",
    title: "Método C.A.T",
    role: "Lojista",
    description:
      "Para donos de loja que querem escalar o negócio, organizar o financeiro e criar uma marca forte no varejo.",
    highlights: ["Planejamento financeiro e precificação", "Visual merchandising CAT", "Marketing local e digital", "E-commerce + loja física"],
    price: "R$ 1.894,40",
    kiwifyUrl: "https://pay.kiwify.com.br/Utu5OHX",
    image: "https://readdy.ai/api/search-image?query=two%20beautiful%20female%20boutique%20owners%20posing%20together%20in%20a%20luxury%20fashion%20store%2C%20left%20woman%20has%20very%20dark%20black%20long%20straight%20hair%20dark%20brunette%20olive%20skin%2C%20right%20woman%20has%20platinum%20blonde%20hair%20fair%20skin%2C%20strong%20contrast%20between%20dark%20and%20light%20hair%2C%20both%20wearing%20chic%20elegant%20blazers%2C%20high-class%20sophisticated%20confident%20smiles%2C%20warm%20golden%20boutique%20lighting%2C%20marble%20floors%20and%20curated%20clothing%20racks%20in%20background%2C%20editorial%20portrait%20photography%2C%20aspirational%20successful%20business%20partners%20aesthetic&width=600&height=700&seq=prod-lojista3&orientation=portrait&nocache=true",
  },
];

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Método C.A.T — Cursos Clientizah",
  description:
    "Trilhas de formação em vendas, liderança e gestão para o varejo. Escolha o curso ideal para o seu perfil profissional.",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@type": "Course",
        name: "Método C.A.T — Vendedora",
        url: `${siteUrl}/inscricao`,
        offers: { "@type": "Offer", price: "498.50", priceCurrency: "BRL" },
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@type": "Course",
        name: "Método C.A.T — Gerente",
        url: `${siteUrl}/gerente`,
        offers: { "@type": "Offer", price: "984.50", priceCurrency: "BRL" },
      },
    },
    {
      "@type": "ListItem",
      position: 3,
      item: {
        "@type": "Course",
        name: "Método C.A.T — Lojista",
        url: `${siteUrl}/lojista`,
        offers: { "@type": "Offer", price: "1894.40", priceCurrency: "BRL" },
      },
    },
  ],
};

export default function NossosProdutos() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-white">
      <title>Nossos Produtos | Método C.A.T — Cursos de Vendas, Liderança e Gestão | Clientizah</title>
      <meta name="description" content="Conheça as três trilhas do Método C.A.T da Clientizah: Vendedora, Gerente e Lojista. Cursos completos de vendas, liderança e gestão para o varejo com Gleice Lyra." />
      <meta name="keywords" content="método CAT, cursos varejo, curso vendedora, curso gerente, curso lojista, Clientizah, Gleice Lyra, vendas varejo, liderança varejo, gestão loja" />
      <link rel="canonical" href={`${siteUrl}/nossos-produtos`} />
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-[160px]">
        {/* Header */}
        <section className="py-16 px-6 md:px-16 bg-[#f9f8f6]">
          <div className="max-w-7xl mx-auto text-center">
            <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-3">Nossos Produtos</p>
            <h1 className="text-4xl md:text-5xl font-light text-black tracking-tight mb-4">
              Método C.A.T
            </h1>
            <p className="text-[#b8962e] text-sm tracking-[0.2em] uppercase font-medium mb-5">
              Cliente · Atenção · Todo tempo
            </p>
            <p className="text-gray-500 text-base leading-relaxed max-w-xl mx-auto">
              Escolha a trilha feita para o seu perfil. Cada módulo foi construído com base em mais de 2 anos de pesquisa e quase 30 anos de experiência real no varejo — em multimarcas e franquias no Brasil e no exterior — para entregar exatamente o que a sua função exige.
            </p>
          </div>
        </section>

        {/* Product cards */}
        <section className="py-20 px-6 md:px-16 bg-white">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            {products.map((p) => (
              <div
                key={p.slug}
                onClick={() => navigate(p.slug)}
                className="group border border-gray-100 hover:border-[#b8962e]/50 transition-all duration-300 cursor-pointer overflow-hidden"
              >
                {/* Image */}
                <div className="relative w-full h-72 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.role}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <span className="absolute top-4 left-4 text-[10px] tracking-[0.25em] uppercase bg-[#b8962e] text-white px-3 py-1 font-medium">
                    {p.tag}
                  </span>
                  <div className="absolute bottom-4 left-4">
                    <p className="text-white/70 text-xs tracking-widest uppercase">{p.title}</p>
                    <h3 className="text-white text-2xl font-semibold tracking-tight">{p.role}</h3>
                  </div>
                </div>

                {/* Content */}
                <div className="p-7">
                  <p className="text-gray-500 text-xs leading-relaxed mb-5">{p.description}</p>
                  <ul className="space-y-2 mb-6">
                    {p.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2 text-xs text-gray-600">
                        <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                          <i className="ri-check-line text-[#b8962e]"></i>
                        </span>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div>
                      <p className="text-[10px] text-gray-400 uppercase tracking-widest">A partir de</p>
                      <p className="text-black font-semibold text-lg">{p.price}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <button className="whitespace-nowrap flex items-center gap-2 text-xs tracking-widest uppercase font-medium text-black group-hover:text-[#b8962e] transition cursor-pointer">
                        Ver curso
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-arrow-right-line"></i>
                        </span>
                      </button>
                      <a
                        href={p.kiwifyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="whitespace-nowrap inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase font-medium bg-[#b8962e] text-white px-3 py-1.5 rounded-md hover:bg-[#a07d1f] transition cursor-pointer"
                      >
                        Comprar na Kiwify
                        <span className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-external-link-line text-[10px]"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-20 px-6 md:px-16 bg-[#f9f8f6]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-14">
              <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-3">Depoimentos</p>
              <h2 className="text-3xl md:text-4xl font-light text-black tracking-tight mb-4">
                O que dizem nossas alunas
              </h2>
              <p className="text-gray-500 text-sm max-w-md mx-auto leading-relaxed">
                Resultados reais de quem aplicou o Método C.A.T no dia a dia do varejo.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Depoimento 1 — Vendedora */}
              <div className="bg-white p-8 border border-gray-100 flex flex-col">
                <div className="flex mb-5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#b8962e] text-sm"></i>
                    </span>
                  ))}
                </div>
                <blockquote className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">
                  "Antes do Método CAT eu travava na hora de abordar o cliente. Hoje consigo conduzir o atendimento com confiança e minhas vendas aumentaram mais de 40% em dois meses. A Gleice explica de um jeito que você consegue aplicar no mesmo dia."
                </blockquote>
                <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                  <div className="w-12 h-12 shrink-0 overflow-hidden rounded-full">
                    <img
                      src="https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20Brazilian%20woman%20smiling%20warmly%2C%20professional%20headshot%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20approachable%20expression%2C%20dark%20hair%2C%20casual%20elegant%20style%2C%20high%20quality%20photo%2C%20realistic%20skin%20texture&width=120&height=120&seq=testimonial-vendedora-1&orientation=squarish"
                      alt="Fernanda Rocha"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-black text-sm font-semibold">Fernanda Rocha</p>
                    <p className="text-gray-400 text-xs tracking-wide">Vendedora — São Paulo, SP</p>
                    <span className="inline-block mt-1 text-[10px] tracking-widest uppercase text-[#b8962e] border border-[#b8962e]/30 px-2 py-0.5">
                      Método C.A.T Vendedora
                    </span>
                  </div>
                </div>
              </div>

              {/* Depoimento 2 — Gerente */}
              <div className="bg-white p-8 border border-gray-100 flex flex-col">
                <div className="flex mb-5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#b8962e] text-sm"></i>
                    </span>
                  ))}
                </div>
                <blockquote className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">
                  "O módulo de métricas gerenciais mudou completamente a forma como eu acompanho minha equipe. Implementei os KPIs da Gleice e em 30 dias minha loja bateu a meta mensal pela primeira vez em seis meses. Conteúdo denso e extremamente prático."
                </blockquote>
                <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                  <div className="w-12 h-12 shrink-0 overflow-hidden rounded-full">
                    <img
                      src="https://readdy.ai/api/search-image?query=portrait%20of%20a%20mature%20confident%20Brazilian%20woman%20with%20a%20professional%20look%2C%20warm%20smile%2C%20leadership%20presence%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20elegant%20appearance%2C%20business%20casual%20attire%2C%20realistic%20photo%20quality&width=120&height=120&seq=testimonial-gerente-1&orientation=squarish"
                      alt="Carla Mendonça"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-black text-sm font-semibold">Carla Mendonça</p>
                    <p className="text-gray-400 text-xs tracking-wide">Gerente de Loja — Belo Horizonte, MG</p>
                    <span className="inline-block mt-1 text-[10px] tracking-widest uppercase text-[#b8962e] border border-[#b8962e]/30 px-2 py-0.5">
                      Método C.A.T Gerente
                    </span>
                  </div>
                </div>
              </div>

              {/* Depoimento 3 — Lojista */}
              <div className="bg-white p-8 border border-gray-100 flex flex-col">
                <div className="flex mb-5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#b8962e] text-sm"></i>
                    </span>
                  ))}
                </div>
                <blockquote className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">
                  "Apliquei o OTB e o Sell-through que aprendi no curso e consegui reduzir meu estoque encalhado em 60%. A aula sobre Black Friday então foi ouro — esse ano foi o melhor resultado da história da minha loja. Recomendo de olhos fechados."
                </blockquote>
                <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                  <div className="w-12 h-12 shrink-0 overflow-hidden rounded-full">
                    <img
                      src="https://readdy.ai/api/search-image?query=portrait%20of%20a%20successful%20Brazilian%20woman%20entrepreneur%2C%20boutique%20owner%20aesthetic%2C%20relaxed%20confident%20smile%2C%20stylish%20appearance%2C%20clean%20light%20background%2C%20natural%20soft%20lighting%2C%20business%20owner%20vibe%2C%20realistic%20high%20quality%20headshot&width=120&height=120&seq=testimonial-lojista-1&orientation=squarish"
                      alt="Patrícia Souza"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-black text-sm font-semibold">Patrícia Souza</p>
                    <p className="text-gray-400 text-xs tracking-wide">Lojista — Curitiba, PR</p>
                    <span className="inline-block mt-1 text-[10px] tracking-widest uppercase text-[#b8962e] border border-[#b8962e]/30 px-2 py-0.5">
                      Método C.A.T Lojista
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Stats bar */}
            <div className="mt-14 grid grid-cols-3 gap-0 border border-gray-200 divide-x divide-gray-200">
              {[
                { value: "+12.000", label: "Alunas formadas" },
                { value: "4,9 / 5,0", label: "Avaliação média dos cursos" },
                { value: "97%", label: "Recomendam o Método CAT" },
              ].map((stat) => (
                <div key={stat.label} className="py-8 text-center">
                  <p className="text-2xl font-semibold text-black mb-1">{stat.value}</p>
                  <p className="text-gray-400 text-xs tracking-widest uppercase">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Instructor strip */}
        <section className="py-14 px-6 md:px-16 bg-[#111]">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
            <div className="w-20 h-20 shrink-0 overflow-hidden rounded-full border-2 border-[#b8962e]/40">
              <img src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8"
                alt="Gleice Lyra" className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-1">Criadora do Método</p>
              <h3 className="text-white text-xl font-semibold mb-2">Gleice Lyra</h3>
              <p className="text-white/50 text-sm leading-relaxed max-w-2xl">
                Referência nacional em varejo, vendas e experiência do cliente. Mais de 15 anos transformando equipes e negócios em todo o Brasil.
              </p>
            </div>
            <div className="flex gap-10 shrink-0">
              <div className="text-center">
                <span className="text-2xl font-bold text-white">+12k</span>
                <p className="text-white/40 text-xs tracking-widest uppercase mt-1">Alunos</p>
              </div>
              <div className="text-center">
                <span className="text-2xl font-bold text-white">3</span>
                <p className="text-white/40 text-xs tracking-widest uppercase mt-1">Trilhas</p>
              </div>
              <div className="text-center">
                <span className="text-2xl font-bold text-white">+30h</span>
                <p className="text-white/40 text-xs tracking-widest uppercase mt-1">Por curso</p>
              </div>
            </div>
          </div>
        </section>

        <CourseFAQ />
      </main>
      <Footer />
    </div>
  );
}
